<mat-card class="cardWithShadow theme-card">
  <mat-card-content class="b-t-1" id="chart-container">
    <h3>Factorizaciones Mensuales(por monto)</h3>
    <div *ngIf="booleanFlag">
      <apx-chart
        [series]="gredientChartOptions.series"
        [chart]="gredientChartOptions.chart"
        [stroke]="gredientChartOptions.stroke"
        [xaxis]="gredientChartOptions.xaxis"
        [fill]="gredientChartOptions.fill"
        [markers]="gredientChartOptions.markers"
        [yaxis]="gredientChartOptions.yaxis"
        [plotOptions]="gredientChartOptions.plotOptions"
        [tooltip]="gredientChartOptions.tooltip"
        [annotations]="gredientChartOptions.annotations"
        [grid]="gredientChartOptions.grid"
        [dataLabels]="gredientChartOptions.dataLabels"
        #chart
      >
      </apx-chart>
    </div>
    <div class="spinner">
      <mat-spinner *ngIf="!booleanFlag"></mat-spinner>
    </div>
  </mat-card-content>
</mat-card>
